import React, { useEffect } from 'react';
import { useAppDispatch } from 'hooks';

import { ContainerHeader, TabContainer } from '~components';
import { faHandHoldingHeart } from '~components/icon';

import { toggleQuickMenu } from '~main/reducers/app';

import ACFRReport from '~support-at-home/components/reports/ACFRReport';
import ACFRItemsTab from '~support-at-home/components/reports/ACFRItemsTab';
import { BudgetDashboard } from './BudgetDashboard';
import { ClaimItemsDashboard } from './ClaimItemsDashboard';
import { StatementsDashboard } from './StatementsDashboard';

const tabs = [
  { id: 'sah-dashboard-budgets', title: 'Budgets', component: BudgetDashboard },
  { id: 'sah-dashboard-claim-items', title: 'Claim Items', component: ClaimItemsDashboard },
  { id: 'sah-dashboard-statements', title: 'Statements', component: StatementsDashboard },
  { id: 'sah-dashboard-acfr', title: 'ACFR Report', component: ACFRReport },
  { id: 'sah-dashboard-acfr-items', title: 'ACFR Items', component: ACFRItemsTab },
];

const DashboardContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(toggleQuickMenu(true));

    return () => {
      dispatch(toggleQuickMenu(false));
    };
  }, []);

  return (
    <div className="p-2">
      <ContainerHeader icon={faHandHoldingHeart} iconSize="1x" className="info" dataCy="support-at-home-header">
        Support At Home - Dashboard
      </ContainerHeader>
      <div className="sah-container">
        <TabContainer tabs={tabs} />
      </div>
    </div>
  );
};

export default DashboardContainer;
